module.exports = __webpack_public_path__ + "static/img/7.3bd3939.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/7.png
// module id = 2BL+
// module chunks = 0